import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// import * as jwt_decode from 'jwt-decode';
import { Config } from 'src/app/config';
import { PasswordRequirements } from 'src/app/models/PasswordRequirements';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  constructor(private http: HttpClient, private config: Config) { }

  login(username: string, password: string) {
    return this.http.post<any>(this.config.getBaseUrl() + `/Api/Auth/Login`, { username, password }, { withCredentials : true })
      .pipe(map(user => {
        this.storeUserSession(user);
        return user;
      }));
  }

  // Stores the user details and jwt token in local storage to keep the user logged in between page refreshes
  storeUserSession(user: any) {
    if (user && user.token) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    }
  }

  refreshToken(request: any) {
    return this.http.post(this.config.getBaseUrl() + "/Api/Auth/RefreshAsync", request);
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }

  getUserDetails(): any {
    return this.http.get<any>(this.config.getBaseUrl() + '/Api/Auth/MyProfile');
  }

  updateProfile(user: any) {
    return this.http.post<any>(this.config.getBaseUrl() + `/Api/Auth/MyProfile`, user);
  }

  // Updates user notification preferences
  updateNotificationPreferences(preferences: any) {
    return this.http.post<any>(this.config.getBaseUrl() + `/Api/Auth/NotificationSettings`, preferences);
  }

  getTokens() {
    var data = localStorage.getItem('currentUser');

    if (data) {
      var currentUser = JSON.parse(data);

      if (currentUser.token) {
        return {
          token: currentUser.token,
          refreshToken: currentUser.refreshToken
        }
      }      
    }

    return null;    
  }

  sendPasswordResetEmail(username: string) {
    return this.http.post<any>(this.config.getBaseUrl() + '/Api/Auth/SendPasswordReset', {}, {
      params: {
        username: username
      }
    });
  }

  resetPassword(username: string, code: string, password: string, confirmPassword: string) {
    return this.http.post<any>(this.config.getBaseUrl() + `/Api/Auth/ResetPassword`, {
      username: username,
      code: encodeURIComponent(code),
      password: password,
      confirmPassword: confirmPassword
    });
  }

  checkRegistrationInfo(username: string, code: string) {
    return this.http.get<any>(this.config.getBaseUrl() + `/Api/Auth/RegistrationInfo`, {
      params: {
        username: username,
        code: encodeURIComponent(code)
      }
    });
  }

  register(username: string, code: string, password: string, confirmPassword: string) {
    return this.http.post<any>(this.config.getBaseUrl() + `/Api/Auth/Register`, {
      username: username,
      code: encodeURIComponent(code),
      password: password,
      confirmPassword: confirmPassword
    });
  }

  resendActivationEmail(username: string) {
    return this.http.post<any>(this.config.getBaseUrl() + '/Api/Auth/ResendActivation', {}, {
      params: {
        username: username
      }
    });
  }

  // Returns the password policy configured in Identity on the api
  getPasswordRequirements() {
    return this.http.get<PasswordRequirements>(this.config.getBaseUrl() + `/Api/Auth/PasswordRequirements`);
  }

  changePassword(password: string, newPassword: string, confirmPassword: string) {
    return this.http.post<any>(this.config.getBaseUrl() + `/Api/Auth/ChangePassword`, {
      currentPassword: password,
      newPassword: newPassword,
      confirmNewPassword: confirmPassword
    });
  }

  
}
